'use strict';

exports.__esModule = true;
var locations = exports.locations = [{
    name: 'London, UK',
    value: {
        lat: parseFloat('51.5073509'),
        lng: parseFloat('-0.12775829999998223')
    },
    placeId: 'ChIJdd4hrwug2EcRmSrV3Vo6llI'
}];

var googleLocations = exports.googleLocations = [{
    formatted_address: 'London, UK',
    geometry: {
        location: {
            lat: function lat() {
                return '51.5073509';
            },
            lng: function lng() {
                return '-0.12775829999998223';
            }
        }
    },
    types: ["locality", "political"]
}];


// WEBPACK FOOTER //
// ./components/search-page/lib/data/locations.js